export const USER_AUTH_KEY = '_baas_ua';
export const REFRESH_TOKEN_KEY = '_baas_rt';
export const USER_AUTH_COOKIE_NAME = 'baas_ua';
export const DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = 10;
